<template>
    
    <div>
        <base-header type="gradient-success" class="pb-6 pt-3 pt-md-5">
        <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center pt-4">
                    <div class="col-lg-6 col-7">
                      
                    </div>
                </div>
            </div>
        </div>
  
        </base-header>
        <InitVisit :jobs="newjobs" :autorefesh="autorefesh" @checkRefesh="checkRefesh" :location="curlocation" :thecong="thecong" @deleteThe="deleteThe"></InitVisit>
        <layer1  :jobs="joblayer1" :thechucnang="thechucnang" @addThe="addThe" @deleteThe="deleteThe"></layer1>
        <layer2 :jobs="joblayer2" :thenoc="thenoc" @addThe="addThe" @deleteThe="deleteThe"></layer2>
        <layer3 :jobs="joblayer3" @addThe="addThe"></layer3>
    </div>
 
</template>
<script>
  import InitVisit from './InitVisit'
  import layer1 from './Layer1'
  import layer2 from './Layer2'
  import layer3 from './Layer3'
  import { mapGetters }  from 'vuex'
  export default {
    components: {
      InitVisit,
      layer1,
      layer2,
      layer3
    },

      data() {
          return {
            polling: null,
            autorefesh: { checked: false},
            thecong: null,
            thechucnang: null,
            thenoc: null,
            url: 'http://222.255.100.41:3055/',
          }
      },
      methods: {
        async initjob() {
          let res = await this.$http.get('/jobs', {params: {location:this.$store.getters.curlocation, openning: true}})
          let jobs = res.data;
          this.$store.dispatch('getcurrentjobs',jobs);
          res = await this.$http.get(this.url, {params:{location:this.$store.getters.curlocation, layer:0}});
          this.thecong = res.data.available.split(',');
          res = await this.$http.get(this.url, {params:{location:this.$store.getters.curlocation, layer:1}});
          this.thechucnang = res.data.available.split(',');
          res = await this.$http.get(this.url, {params:{location:this.$store.getters.curlocation, layer:2}});
          this.thenoc = res.data.available.split(',');
        },
        getjobs() {
          this.polling = setInterval(async() => {
            if(this.autorefesh.checked){
              let res = await this.$http.get('/jobs', {params: {location:this.$store.getters.curlocation, openning: true}})
              let jobs = res.data
              if(JSON.stringify(jobs) != JSON.stringify(this.$store.state.jobs)){
                this.$store.dispatch('getcurrentjobs',jobs)
              }
              res = await this.$http.get(this.url, {params:{location:this.$store.getters.curlocation, layer:0}});
              this.thecong = res.data.available.split(',');
              res = await this.$http.get(this.url, {params:{location:this.$store.getters.curlocation, layer:1}});
              this.thechucnang = res.data.available.split(',');
              res = await this.$http.get(this.url, {params:{location:this.$store.getters.curlocation, layer:2}});
              this.thenoc = res.data.available.split(',');
            }
          }, 20000)
        },
        async deleteThe(card){
          if(card.layer == 0) {
            let data = { 
            location: this.$store.getters.curlocation,
            layer: 0,
            id: card.id};
            for(let i =0;i< this.thecong.length;i++){
              if(this.thecong[i] == card.id){
                this.thecong.splice(i, 1);
                i--;
              }
            }
            await this.$http.post(this.url + 'add', data);
          }
          else if(card.layer == 1) {
            let data = { 
            location: this.$store.getters.curlocation,
            layer: 1,
            id: card.id};
            for(let i =0;i< this.thechucnang.length;i++){
              if(this.thechucnang[i] == card.id){
                this.thechucnang.splice(i, 1);
                i--;
              }
            }
            await this.$http.post(this.url+'add', data);
          }
          else if(card.layer == 2) {
            let data = { 
            location: this.$store.getters.curlocation,
            layer: 2,
            id: card.id};
            for(let i =0;i< this.thenoc.length;i++){
              if(this.thenoc[i] == card.id){
                this.thenoc.splice(i, 1);
                i--;
              }
            }
            await this.$http.post(this.url+'add', data);
          }

        },
        async addThe(card) {
          if(card.layer== 0) {
            let data = {
            location: this.$store.getters.curlocation,
            id: card.id,
            layer: 0
            };
            this.thecong.push(card.id);
            await this.$http.post(this.url+'delete', data);
          }
          else if(card.layer== 1) {
            let data = {
            location: this.$store.getters.curlocation,
            id: card.id,
            layer: 1
            };
            this.thechucnang.push(card.id);
            await this.$http.post(this.url+'delete', data);
          }
          else if(card.layer== 2) {
            let data = {
            location: this.$store.getters.curlocation,
            id: card.id,
            layer: 2
            };
            this.thenoc.push(card.id);
            await this.$http.post(this.url+'delete', data);
          }
        },
        checkRefesh() {
          this.autorefesh.checked = !this.autorefesh.checked;
        }

      },
      computed: 
        mapGetters(['curlocation','newjobs', 'joblayer1', 'joblayer2', 'joblayer3'])     
      ,
      mounted() {
        this.initjob()
        this.getjobs()
      },
      created() {

      },
      beforeDestroy() {
        clearInterval(this.polling);
      }
  }
</script>
<style>
</style>
